import { useState } from 'react';
import { api } from '../lib/api.js';

// Roast Curve launcher (Docket #45, 2026-07-24) — mirror of TallyLaunchView.
// Roast Curve is the coffee QC + roasting-education app, a separate service
// fronted by Monarch's identity. Opening it is a full-page navigation that
// needs a signed handoff (see server/features/roastcurve/proxy-routes.js);
// the button fetches a 60s token and opens /roastcurve/ in a new tab,
// already signed in. This card is the fallback when the direct menu-click
// handoff fails, so the error shows with a retry.
export function RoastCurveLaunchView({ user }) {
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  async function open() {
    setBusy(true); setErr('');
    try {
      const r = await api('POST', '/api/roastcurve/handoff', {}, { 'x-user-id': String(user.id) });
      window.open(r.url, '_blank', 'noopener');
    } catch (e) {
      let m = e.message; try { m = JSON.parse(e.message).error; } catch {}
      setErr(m || 'Could not open Roast Curve.');
    } finally { setBusy(false); }
  }

  return (
    <div className="card" style={{ maxWidth: 520 }}>
      <div className="text-base font-semibold mb-1">Roast Curve</div>
      <div className="text-sm text-gray-500 mb-4">
        Roast capture, release gates, cupping, and roasting training. Every
        batch gets a curve; every release gets a decision. Opens in a new
        tab — you're already signed in.
      </div>
      <button className="btn-primary" onClick={open} disabled={busy}>
        {busy ? 'Opening…' : 'Open Roast Curve →'}
      </button>
      {err && <div className="text-xs text-red-700 mt-3">{err}</div>}
    </div>
  );
}
